import { createGlobalStyle } from 'styled-components';
import { activeTheme, flattenTokens, themes } from './index';

const declarations = (colors) =>
    flattenTokens(colors)
        .map(([name, value]) => `${name}: ${value};`)
        .join('\n');

// Publica os tokens do tema ativo como CSS variables em :root.
// [data-theme="default"] reaplica o tema padrão num trecho da árvore
// (usado pelo ThemeScope nas páginas de clube, que mantêm a identidade própria).
const ThemeVars = createGlobalStyle`
    :root {
        ${declarations(activeTheme.colors)}
    }

    [data-theme="default"] {
        ${declarations(themes.default.colors)}
    }
`;

export default ThemeVars;
